import initializeSentry from '../nuxt-module/src/runtime/sentry'

export default defineNuxtPlugin((nuxtApp) => {
  return initializeSentry({
    nuxtApp,
    dsn: 'https://0351a7dddd9341dfa8cdb3f75c22c51e@o129050.ingest.sentry.io/4505033110257664',
    replayNetworkDetailAllowUrls: [
      'https://api.genoplan.co.kr',
      'https://testapi.genoplan.co.kr',
    ],
  })
})
